function studioBackend(value) {
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password && url.pathname === '/' && !url.search && !url.hash ? url.origin : null;
  } catch { return null; }
}
function studioLine(value) {
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  if (!value || typeof value !== 'object' || Array.isArray(value) || Object.keys(value).some(key => !['id', 'quantity', 'properties'].includes(key))) return null;
  if (!Number.isSafeInteger(value.id) || value.id < 1 || !Number.isInteger(value.quantity) || value.quantity < 1 || value.quantity > 20) return null;
  const properties = value.properties;
  if (!properties || typeof properties !== 'object' || Array.isArray(properties) || Object.keys(properties).length !== 3 || Object.keys(properties).some(key => !['_studio_order', '_studio_line', '_studio_proof'].includes(key))) return null;
  if (typeof properties._studio_order !== 'string' || !uuid.test(properties._studio_order) || typeof properties._studio_line !== 'string' || !uuid.test(properties._studio_line) || typeof properties._studio_proof !== 'string' || !/^[0-9a-f]{64}$/i.test(properties._studio_proof)) return null;
  return {id: value.id, quantity: value.quantity, properties: {_studio_order: properties._studio_order, _studio_line: properties._studio_line, _studio_proof: properties._studio_proof}};
}
function studioCheckoutTarget(value, shopHost, extraHost) {
  try {
    const url = new URL(value);
    const allowed = [shopHost, extraHost].filter(host => typeof host === 'string' && /^[a-z0-9]+(?:[.-][a-z0-9]+)*\.[a-z]{2,}$/i.test(host));
    return url.protocol === 'https:' && !url.username && !url.password && !url.port && allowed.includes(url.hostname) && url.pathname === '/checkout' && !url.search && !url.hash ? url.href : null;
  } catch { return null; }
}
function studioManifest(data, cart) {
  const uuid = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  const proof = /^[0-9a-f]{64}$/i;
  if (!data || !data.attributes || Object.keys(data.attributes).length !== 2 || !uuid.test(data.attributes._studio_order || '') || !proof.test(data.attributes._studio_order_proof || '') || !Array.isArray(data.lines) || data.lines.length !== cart.items.length || !data.lines.length) return false;
  const keys = new Set();
  const ids = new Set();
  return data.lines.every(line => {
    const original = cart.items.find(item => item.key === line.key);
    if (!original || keys.has(line.key) || !Number.isSafeInteger(line.variantId) || line.variantId !== original.variant_id || !Number.isInteger(line.quantity) || line.quantity < 1 || line.quantity > 20 || line.quantity !== original.quantity || !line.properties || Object.keys(line.properties).length !== 3 || line.properties._studio_order !== data.attributes._studio_order || !uuid.test(line.properties._studio_line || '') || !proof.test(line.properties._studio_proof || '') || ids.has(line.properties._studio_line)) return false;
    keys.add(line.key);
    ids.add(line.properties._studio_line);
    return true;
  });
}
function studioCartMatches(cart, manifest) {
  if (!cart || !cart.attributes || cart.attributes._studio_order !== manifest.attributes._studio_order || cart.attributes._studio_order_proof !== manifest.attributes._studio_order_proof || !Array.isArray(cart.items) || cart.items.length !== manifest.lines.length) return false;
  const ids = new Set();
  return cart.items.every(item => {
    const properties = item.properties || {};
    const line = manifest.lines.find(value => value.properties._studio_line === properties._studio_line);
    if (!line || ids.has(properties._studio_line) || properties._studio_order !== manifest.attributes._studio_order || item.variant_id !== line.variantId || item.quantity !== line.quantity || properties._studio_proof !== line.properties._studio_proof) return false;
    ids.add(properties._studio_line);
    return true;
  });
}
(() => {
  const configNode = document.getElementById('studio-settings');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const backend = studioBackend(config.backend);
  const root = config.root.endsWith('/') ? config.root : config.root + '/';
  const frame = document.querySelector('[data-studio-builder]');
  const status = document.querySelector('[data-builder-status]');
  let adding = false;
  if (frame && backend) {
    const source = new URL('/builder', backend);
    source.searchParams.set('parentOrigin', window.location.origin);
    frame.addEventListener('load', () => frame.contentWindow.postMessage({type: 'studio-blauw:init', version: 1}, backend));
    window.addEventListener('message', async event => {
      if (event.origin !== backend || event.source !== frame.contentWindow || !event.data || typeof event.data !== 'object' || event.data.version !== 1) return;
      if (event.data.type === 'studio-blauw:ready') { if (status) status.hidden = true; return; }
      if (event.data.type === 'studio-blauw:resize') {
        if (Number.isInteger(event.data.height) && event.data.height >= 200 && event.data.height <= 10000) frame.style.height = event.data.height + 'px';
        return;
      }
      if (event.data.type !== 'studio-blauw:add-line' || adding) return;
      const line = studioLine(event.data.line);
      if (!line) { frame.contentWindow.postMessage({type: 'studio-blauw:cart-result', version: 1, ok: false, error: config.text.builderFailure}, backend); return; }
      adding = true;
      if (status) { status.hidden = false; status.textContent = config.text.adding; }
      try {
        const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({items: [line]})});
        if (!response.ok) throw new Error(config.text.builderFailure);
        frame.contentWindow.postMessage({type: 'studio-blauw:cart-result', version: 1, ok: true}, backend);
        window.location.assign(root + 'cart');
      } catch {
        adding = false;
        if (status) status.textContent = config.text.builderFailure;
        frame.contentWindow.postMessage({type: 'studio-blauw:cart-result', version: 1, ok: false, error: config.text.builderFailure}, backend);
      }
    });
    frame.src = source.href;
  } else if (frame) {
    frame.hidden = true;
    if (status) status.textContent = config.text.disconnected;
  }
  const checkout = document.querySelector('[data-studio-checkout]');
  if (!checkout) return;
  const button = checkout.querySelector('button[type=submit]');
  const errorNode = checkout.querySelector('[data-checkout-error]');
  button.disabled = !backend;
  checkout.addEventListener('submit', async event => {
    event.preventDefault();
    if (!backend || button.disabled) return;
    button.disabled = true;
    errorNode.hidden = true;
    const label = button.textContent;
    button.textContent = config.text.busy;
    try {
      const cartResponse = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!cartResponse.ok) throw new Error(config.text.checkoutFailure);
      const nativeCart = await cartResponse.json();
      const cart = {items: nativeCart.items.map(item => ({key: item.key, variant_id: item.variant_id, quantity: item.quantity, properties: item.properties || {}}))};
      const response = await fetch(backend + '/api/theme/checkout', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, credentials: 'omit', body: JSON.stringify({cart, country: config.country})});
      const data = await response.json();
      if (!response.ok) throw new Error(typeof data.error === 'string' ? data.error : config.text.checkoutFailure);
      const target = studioCheckoutTarget(data.url, config.shopHost, config.checkoutHost) || studioCheckoutTarget(data.url, window.location.hostname, '');
      if (!target || !studioManifest(data, cart)) throw new Error(config.text.checkoutFailure);
      for (const line of data.lines) {
        const original = cart.items.find(item => item.key === line.key);
        const properties = {...original.properties, ...line.properties};
        const update = await fetch(root + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({id: line.key, quantity: line.quantity, properties})});
        if (!update.ok) throw new Error(config.text.checkoutFailure);
      }
      const update = await fetch(root + 'cart/update.js', {method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({attributes: data.attributes})});
      if (!update.ok) throw new Error(config.text.checkoutFailure);
      const fresh = await fetch(root + 'cart.js', {headers: {Accept: 'application/json'}, cache: 'no-store'});
      if (!fresh.ok || !studioCartMatches(await fresh.json(), data)) throw new Error(config.text.checkoutFailure);
      window.location.assign(target);
    } catch (error) {
      errorNode.hidden = false;
      errorNode.textContent = error instanceof Error ? error.message : config.text.checkoutFailure;
      button.disabled = false;
      button.textContent = label;
    }
  });
})();
